import { Stack } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarProps,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import React from 'react';

interface DatasetToolbarProps extends GridToolbarProps {
  // Used by the export action so downloaded CSV files are contextual and traceable.
  csvFileName: string;
}

// Shared DataGrid toolbar for dataset previews.
// Keeps common controls (filter/density/export/search) in one place.
const DatasetToolbar: React.FC<React.PropsWithChildren<DatasetToolbarProps>> = ({ csvFileName, ...props }) => (
  <GridToolbarContainer sx={{ px: 0.5, py: 0.75, justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      <GridToolbarFilterButton {...props} />
      <GridToolbarDensitySelector {...props} />
      <GridToolbarExport {...props} csvOptions={{ utf8WithBom: true, fileName: csvFileName }} />
    </Stack>
    <GridToolbarQuickFilter debounceMs={250} size="small" />
  </GridToolbarContainer>
);

export default DatasetToolbar;
